import { render, staticRenderFns } from "./c-card@.vue?vue&type=template&id=33513272&"
import script from "./c-card@.vue?vue&type=script&lang=ts&"
export * from "./c-card@.vue?vue&type=script&lang=ts&"
import style0 from "./c-card@.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports